module.exports = __webpack_public_path__ + "static/media/frontline-10-moodboard.daf053d1.png";